import api from '@shared/services/api.js';

export const getServicingProviders = async organizationId => {
  return api.get(
    `/api/v1/organizations/${organizationId}/servicing_providers/`,
  );
};
